import AHref from "../../../../../../../components/ahref/ahref";
import { Badge, BadgeType } from "../../../../../../../components/badge/badge";
import FontBody1 from "../../../../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import { rootContainer, TYPE } from "../../../../../../../services/container/root";
import { IIframeService } from "../../../../../../../services/iframe-service/iframe-service";
import './sbr-promo-text.scss';

const SBRPromoText: React.FC = () => {

    const iframService = rootContainer.get<IIframeService>(TYPE.IframService);
    const href = iframService.getInAppRedirectUrl('/dashboard/ship-by-returngo', 'RMA page');
    
    return (
        <div className={'sbr-promo-text'}>
            <Badge type={BadgeType.SUCCESS} text="NEW" />
            <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY3}>Ship by ReturnGO</FontBody1>
            <AHref href={href} target="_blank">
                <FontBody2 variant={FONT_VARIANT.UNDER_LINE} color={FONT_COLOR.PRIMARY3}>Learn more</FontBody2>
            </AHref>
        </div>
    );
}

export default SBRPromoText;